import React, { ChangeEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Button,
  Tabs,
  Tab,
  Box,
  TextField,
  CardMedia,
  Input,
} from "@mui/material";
import EditText from "../../components/editText";
import AddFaq from "../../Modals/addFaq";
import AddIcon from "@mui/icons-material/Add";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import CloseIcon from "@mui/icons-material/Close";
import SwitchToggle from "../../components/SwitchToggle";
import {
  useAddFAQMutation,
  useLazyGetFAQByIdQuery,
  useLazyGetFAQQuery,
  useUpdateFAQMutation,
  useDeleteFAQMutation,
  useLazyGetCMSQuery,
  useUpdateCMSMutation,
} from "../../service/cms";
import { showError, showToast } from "../../constants/toasts";
import moment from "moment";
import Pagination from "../../components/Panigation";
import ConfirmationDialog from "../../Modals/confirmationModal";
import { isValidInput } from "../../utils/validations";
import usePermission from "../../hooks/usePermission";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageCms = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const {
    isView,
    isAdd,
    isEdit: edit,
    isDelete,
  } = usePermission({
    label: "Manage CMS Pages",
    page_permission: "isView",
  });

  const [legal2, setLegal2] = useState<string>("");
  const [legal3, setLegal3] = useState<string>("");
  const [legal4, setLegal4] = useState<string>("");

  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const [error, setError] = useState(false);
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [countryCode, setCountryCode] = useState<string>("");
  const [phoneDisplay, setPhoneDisplay] = useState<string>("");
  const [isEdit, setIsEdit] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState(0);
  const [image, setImage] = useState<string>("");
  const [image2, setImage2] = useState<string>("");
  const [debounceSearchTerm, setDebounceSearchTerm] = useState<string>("");

  const [fileName, setFileName] = useState<string>("");
  const [color, setColor] = useState("#0CD0C6");

  // CMS hooks
  const [getCMS] = useLazyGetCMSQuery();
  const [updateCMS] = useUpdateCMSMutation();

  // FAQ hooks
  const [getFAQ] = useLazyGetFAQQuery();
  const [addFAQ] = useAddFAQMutation();
  const [updateFAQ] = useUpdateFAQMutation();
  const [deleteFAQ, { isLoading: isDeletingFaq }] = useDeleteFAQMutation();

  // FAQ state
  const [faqRows, setFaqRows] = useState<any[]>([]);
  const [faqTotal, setFaqTotal] = useState<number>(0);
  const [faqPage, setFaqPage] = useState<number>(1);
  const [faqLimit] = useState<number>(10);
  const [selectedFaq, setSelectedFaq] = useState<any | null>(null);
  const [deleteOpen, setDeleteOpen] = useState<boolean>(false);

  // Load CMS on mount
  useEffect(() => {
    const loadCMS = async () => {
      try {
        const res = await getCMS({}).unwrap();
        if (res?.code === 200) {
          const d = res?.data || {};
          const cs = d?.contactSupport || {};
          setEmail(cs?.email || d?.email || d?.contactEmail || "");
          setPhone(cs?.phone || d?.phone || d?.contactPhone || "");
          setCountryCode(cs?.countryCode || "");
          setPhoneDisplay(`${cs?.countryCode || ""}${cs?.phone || ""}`);
          setLegal2(d?.legal || d?.terms || "");
          setLegal3(d?.privacyPolicy || d?.privacy || "");
        }
      } catch (error: any) {
        showError(error?.data?.message || "Failed to load CMS");
      }
    };
    loadCMS();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Load FAQs
  const loadFAQs = async (p?: number) => {
    try {
      const res = await getFAQ({
        page: p || faqPage,
        limit: faqLimit,
        ...(searchTerm && { search: debounceSearchTerm }),
      }).unwrap();
      if (res?.code === 200) {
        setFaqRows(res?.data?.list || []);
        setFaqTotal(res?.data?.totalCount || 0);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setFaqRows([]);
      setFaqTotal(0);
    }
  };

  useEffect(() => {
    loadFAQs(1);
    setFaqPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debounceSearchTerm]);

  useEffect(() => {
    loadFAQs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFaqPageChange = (p: number) => {
    setFaqPage(p);
    loadFAQs(p);
  };

  const handleSaveCMS = async () => {
    try {
      if (!email?.trim()) {
        // showError("Email is required");
        return;
      }
      if (!phone?.trim()) {
        // showError("Phone is required");
        return;
      }
      if (!countryCode?.trim()) {
        showError("Country code is required");
        return;
      }
      const body = {
        contactSupport: {
          email: email.trim(),
          phone: phone.trim(),
          countryCode: countryCode.trim(),
        },
        legal: legal2,
        privacyPolicy: legal3,
      };
      const res = await updateCMS({ body }).unwrap();
      if (res?.code === 200) {
        showToast("CMS updated successfully");
      }
    } catch (error: any) {
      showError(error?.data?.message || "Failed to update CMS");
    }
  };

  const openAddFaq = () => {
    setIsEdit(false);
    setSelectedFaq(null);
    setOpenModal(true);
  };

  const openEditFaq = (item: any) => {
    setIsEdit(true);
    setSelectedFaq(item);
    setOpenModal(true);
  };

  const handleSubmitFaq = async (payload: {
    question: string;
    answer: string;
    id?: string;
  }) => {
    try {
      let res;
      if (isEdit && payload.id) {
        res = await updateFAQ({
          id: payload.id,
          body: { question: payload.question, answer: payload.answer },
        }).unwrap();
      } else {
        res = await addFAQ({
          question: payload.question,
          answer: payload.answer,
        }).unwrap();
      }
      if (res?.code === 200) {
        showToast(
          isEdit ? "FAQ updated successfully" : "FAQ added successfully"
        );
        loadFAQs(faqPage);
      }
    } catch (error: any) {
      showError(
        error?.data?.message ||
          (isEdit ? "Failed to update FAQ" : "Failed to add FAQ")
      );
      throw error;
    }
  };

  const handleDeleteFaq = async () => {
    if (!selectedFaq?._id) return;
    try {
      const res = await deleteFAQ({ id: selectedFaq._id }).unwrap();
      if (res?.code === 200) {
        showToast("FAQ deleted successfully");
        setDeleteOpen(false);
        // adjust page if last item deleted
        if (faqRows.length === 1 && faqPage > 1) {
          setFaqPage((prev) => prev - 1);
          loadFAQs(faqPage - 1);
        } else {
          loadFAQs(faqPage);
        }
      }
    } catch (error: any) {
      showError(error?.data?.message || "Failed to delete FAQ");
    }
  };
  return (
    <>
      <div className="main_title">
        <h1>Manage CMS</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          Manage CMS
        </p>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Contact Support" {...a11yProps(0)} />
              <Tab label="Legal" {...a11yProps(1)} />
              <Tab label="Privacy Policy" {...a11yProps(2)} />
              <Tab label="FAQ's" {...a11yProps(3)} />
            </Tabs>
          </Box>
        </div>
      </div>

      <div className="cards">
        <CustomTabPanel value={valueTabs} index={0}>
          <form className="form">
            <div className="gap_p">
              <div className="control_group w_50">
                <label htmlFor="email">Email Address</label>
                <TextField
                  id="email"
                  placeholder="Enter here"
                  fullWidth
                  hiddenLabel
                  value={email}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (isValidInput(value) && value.length <= 100) {
                      setEmail(e.target.value);
                    }
                  }}
                />
                {error && email == "" ? (
                  <h6 className="err_msg">Email is required</h6>
                ) : (
                  ""
                )}
              </div>
              <div className="control_group w_50">
                <label htmlFor="phone">Phone Number</label>
                <PhoneInput
                  country={"in"}
                  placeholder="Enter Phone Number"
                  enableSearch={false}
                  autoFormat={false}
                  inputStyle={{ width: "100%" }}
                  value={phoneDisplay}
                  onChange={(value, country: any) => {
                    const dial = country?.dialCode || "";
                    const number = value?.replace(dial, "");
                    setPhone(number);
                    setCountryCode(dial ? `+${dial}` : "");
                    setPhoneDisplay(value);
                  }}
                />
              </div>
            </div>
           {edit && <div className="form_btn">
              <Button
                className="btn btn_primary"
                onClick={(e) => {
                  e.preventDefault();
                  setError(true);
                  handleSaveCMS();
                }}
              >
                Save
              </Button>
            </div>}
          </form>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <EditText content={legal2} setContent={setLegal2} />
         {edit && <div className="form_btn">
            <Button className="btn btn_primary" onClick={handleSaveCMS}>
              Save
            </Button>
          </div>}
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={2}>
          <EditText content={legal3} setContent={setLegal3} />
         {edit && <div className="form_btn">
            <Button className="btn btn_primary" onClick={handleSaveCMS}>
              Save
            </Button>
          </div>}
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={3}>
          <div className="table_header">
            <div className="left_s">
              <SearchBar
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                setDebouncedSearchTerm={setDebounceSearchTerm}
                placeholder="Search..."
              />
            </div>
          {isAdd &&  <div className="right_s">
              <Button className="btn btn_primary" onClick={openAddFaq}>
                <AddIcon /> Add FAQ
              </Button>
            </div>}
          </div>
          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow hover>
                  <TableCell>Sr.no</TableCell>
                  <TableCell>Question</TableCell>
                  <TableCell>Answer</TableCell>
                  <TableCell>Created Date</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {faqRows?.map((row, idx) => (
                  <TableRow hover key={row?._id || idx}>
                    <TableCell>
                      {(faqPage - 1) * faqLimit + (idx + 1)}
                    </TableCell>
                    <TableCell>{row?.question || "-"}</TableCell>
                    <TableCell className="max_c2">
                      <p>{row?.answer || "-"}</p>
                    </TableCell>
                    <TableCell>
                      {row?.createdAt
                        ? moment(row?.createdAt).format("ll")
                        : "-"}
                    </TableCell>
                    <TableCell>
                      <div className="table_actions v2">
                       {edit && <IconButton onClick={() => openEditFaq(row)}>
                          <img src="/static/images/edit2_icon.svg" alt="" />
                        </IconButton>
                        }
                       {isDelete && <IconButton
                          onClick={() => {
                            setSelectedFaq(row);
                            setDeleteOpen(true);
                          }}
                        >
                          <img src="/static/images/trash2_icon.svg" alt="" />
                        </IconButton>
                        }
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {faqTotal > 0 && (
            <Pagination
              module={faqRows}
              page={faqPage}
              onPageChange={handleFaqPageChange}
              totalPages={Math.ceil(faqTotal / faqLimit)}
              setPage={setFaqPage}
              totalCount={faqTotal}
            />
          )}
        </CustomTabPanel>
      </div>

      <AddFaq
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
        isEdit={isEdit}
        initial={selectedFaq}
        onSubmit={handleSubmitFaq}
      />
      <ConfirmationDialog
        open={deleteOpen}
        onClose={() => setDeleteOpen(false)}
        onConfirm={handleDeleteFaq}
        title="Delete FAQ"
        confirmText="Delete"
        cancelText="Cancel"
        message={`Are you sure you want to delete FAQ "${
          selectedFaq?.question || ""
        }"?`}
        isLoading={isDeletingFaq}
      />
    </>
  );
};

export default ManageCms;
